import api from './api';

const merchantAnalyticsService = {
  getOverview: () => api.get('/merchant-analytics/overview'),
  getRevenue: (days = 30) => api.get('/merchant-analytics/revenue', { params: { days } }),
  getOrders: () => api.get('/merchant-analytics/orders'),
  getProducts: () => api.get('/merchant-analytics/products'),
  getCustomers: () => api.get('/merchant-analytics/customers'),
  getReviews: () => api.get('/merchant-analytics/reviews'),
};

export default merchantAnalyticsService;
